export default __webpack_public_path__ + "static/media/10_c.m._sunshine.8e44194c.png";